import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output} from "@angular/core";
import {User} from "../../../../../../../user/user";
import {
  UserSubscription,
  UserSubscriptionCategory,
  UserSubscriptionType
} from "../../../../../../../user/user-subscription";
import AllPlansFeatures from "./allPlansFeatures.json";
import planFeatures from './planFeatures.json';
import {filter, first} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../../../store";
import {CookieService} from "ngx-cookie";
import {ChosenPlan} from "../../../../../payment-info/models/plan.model";
import {
  CopilotVideoComponent
} from "../../../../../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/copilot-video/copilot-video.component";
import {DbModalService} from "../../../../../../../modules/modal/modal";
import {GoogleAnalyticsService} from "../../../../../../../shared/services/google-analytics/google-analytics.service";
import {DbResponse} from "../../../../../../../shared/interceptors/db-response";
import {AuthService} from "../../../../../../../auth/auth.service";
import {TextUtils} from "../../../../../../../shared/utils/text-utils";
import {SwitchAnnualDialogComponent} from "../../../../../../../workspace/subscription-plan/alernative-subscription-plan/ds-billing-info/switch-annual-dialog/switch-annual-dialog.component";
import {DialogService} from "../../../../../../../../ng2-bootstrap-modal/dialog.service";
import {UserSubscriptionStatus} from "../../../../../../../user/user-subscription-status";


@Component({
    selector: 'db-business-plans',
    templateUrl: './business-plans.component.html',
    styleUrls: ['./business-plans.component.scss'],
    standalone: false
})
export class BusinessPlansComponent implements OnInit {

  @Input() higherPlan: boolean = false;
  @Input() user: User;
  @Input() currentSubscription: UserSubscription;
  @Input() couponPercent: number;
  @Input() couponDays: number;
  @Input() annualPrice: number;
  @Input() periodSwitch: number = 12;
  @Input() subscriptions: UserSubscription[] = [];
  @Input() shouldStackPlans: boolean = false;
  @Input() canSwitch: boolean;
  @Input() showSwitchAnnual: boolean;
  @Input() invitedUser: boolean;
  @Output() onBack = new EventEmitter<string>();
  @Output() onPlanSelect = new EventEmitter<ChosenPlan>();
  @Output() onPaidSelect = new EventEmitter<any>();

  planFeatures = planFeatures;
  chosenPlan: ChosenPlan;
  couponCode: string;
  expirationDate: string;
  allPlansFeatures: any = AllPlansFeatures;
  userSubscriptionStatus: typeof UserSubscriptionStatus = UserSubscriptionStatus;
  UserSubscriptionCategory = UserSubscriptionCategory;
  UserSubscriptionType = UserSubscriptionType;
  planTypeInfo: any[];
  isDropdownOpen = false;
  isTier1Country: boolean;
  applyCouponForPlatform = false;
  hasFreeDays: boolean = false;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _authService: AuthService,
    private _cookieService: CookieService,
    private _modalService: DbModalService,
    private eRef: ElementRef,
    private _dialogService: DialogService,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {
  }

  ngOnInit() {
    const getExperimentalCookie = this._cookieService.get('db-experiment');

    this.isTier1Country = getExperimentalCookie ?
      JSON.parse(getExperimentalCookie) && JSON.parse(getExperimentalCookie).t1PExp && JSON.parse(getExperimentalCookie).t1PExp === 'b' : false;
  }

  public getPlanFeatures(featureType: string, subscription?: UserSubscription) {
    if (!subscription) {
      subscription = this.subscriptions.find(sub => sub?.plan?.periodNumber === this.periodSwitch);
    }
    const category = subscription?.category?.toLowerCase();
    const activeTab = "business";
    if (!category || !planFeatures[category]) {
      return null;
    }
    const planData = planFeatures[category];
    return planData[featureType] || null;
  }

  public replaceParam(string, params: any = null): string {
    return TextUtils.getText(null, params, string);
  }


  chooseSubscription(plan: UserSubscription): void {
    this.chosenPlan = {
      id: plan.id,
      title: plan.plan.title,
      price: plan.plan.planPrice,
      planId: plan.plan.planId,
      tabCategory: plan?.plan?.shortFeatures?.tabCategory,
      category: plan?.type,
      type: this.periodSwitch === 12 ? 'year' : 'month',
      periodNumber: plan.plan.periodNumber,
      coupleId: plan?.coupleId || (plan.plan?.couplePlanId).toString(),
      services: plan?.plan?.services
    };
    const date = new Date();
    date.setDate(date.getDate() + 7);
    this.expirationDate = date.toDateString();
    if (this.currentSubscription?.platformPaidClient) {
      this.onPaidSelect.emit(plan);
    } else {
      this.onPlanSelect.emit(this.chosenPlan);
    }
  }

  openVideoPopup(): void {
    this._modalService.open(CopilotVideoComponent, {
      height: 563, width: 1000, hasOutsideRightCloseBtn: true,
      hasCloseBtn: false, backdrop: 'static'
    });
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event): void {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  isCurrentPlan(plan: UserSubscription): boolean {
    if (!this.currentSubscription || !plan) {
      return false;
    }

    if (this.currentSubscription.id === plan.id ||
      this.currentSubscription.subscriptionId === plan.subscriptionId) {
      return true;
    }

    return this.currentSubscription.category === plan.category &&
      this.currentSubscription.isBusiness === plan.isBusiness &&
      this.currentSubscription.plan.periodNumber === plan.plan.periodNumber;
  }

  private _applyCoupon(subscriptionId, coupon): void {
    this._authService
      .applyCoupon(subscriptionId, coupon)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      )
      .subscribe((response) => {
        if (response.success) {
          this.applyCouponForPlatform = true;
          this.hasFreeDays =
            response.data.free_days_before_payment &&
            response.data.free_days_before_payment !== 0;
        }
      });
  }

  public switchToAnnual(): void {
    this._dialogService
      .addDialog(SwitchAnnualDialogComponent, {
        userSubscription: this.currentSubscription,
        annualPrice: this.annualPrice
      });
  }
}
